import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { colours } from "../Styles";
import pdLogo from '../img/pdLogo.svg';
import Navlist from './Navlist';
import FlexSpaceCenter from './FlexSpaceCenter';
import PromoBanner from './PromoBanner';
import MaxContent from './MaxContent';
import ContactBar from './ContactBar';
import MobileMenu from './MobileMenu';

function Nav() {

  const {transpWhite, medium, dark} = colours;
  const Navigation = styled.div`
    height: 100px;
    width: 100%;
    position: fixed;
    display: flex;
    top: 40px;
    align-items: center;
    justify-content: center;
    background: ${transpWhite};
    transition: top 0.5s;
    z-index: 5;
      .nav-logo {
        height: 50px;
      }
    // Navlist styling
    ul {
        list-style: none;
        display: flex;
        li {
          font-family: "Roboto", sans-serif;
          color: ${medium};
          font-size: 16px;
          margin-left: 25px;
          margin-right: 25px;
          transition: 500ms;
          :hover {
            color: ${dark};
          }
        }
      }
    }
    @media only screen and (max-width: 600px) {
      top: 0;
      height: 80px;
      ul {display: none;}
    }
  `;
  return (
    <div className="navbar">
      <ContactBar/>
      <Navigation>
        <MaxContent>
          <FlexSpaceCenter>
            <Link to='/'>
              <img className='nav-logo' src={pdLogo} alt="precision detail logo"/>
            </Link>
            <Navlist/>
            <MobileMenu/>
          </FlexSpaceCenter>
        </MaxContent>
      </Navigation>
      <PromoBanner/>
    </div>
  );
}

export default Nav;
